"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getMeasurementsQuery_1 = __importDefault(require("./graphql/getMeasurementsQuery"));
const getMeasurementInfo_1 = require("./graphql/getMeasurementInfo");
class Measurements {
    constructor(client) {
        this.getMeasurements = async (customer) => {
            const response = (await this.client.fetch("customersMeasurements", getMeasurementsQuery_1.default, {
                id: parseInt(customer.id),
            }));
            const measurements = [];
            if (!response.coachTrainee.periods) {
                return measurements;
            }
            response.coachTrainee.periods.forEach((period) => {
                if (!period.measurements) {
                    return;
                }
                period.measurements.forEach((measurement) => {
                    measurements.push({
                        id: measurement.createdAt.substr(0, 10),
                        createdAtRaw: measurement.createdAt,
                        createdAt: "",
                        week: measurement.week,
                        height: measurement.height.toFixed(2),
                        weight: measurement.weight.toFixed(2),
                        shoulders: measurement.shoulders.toFixed(2),
                        waist: measurement.waist.toFixed(2),
                        breast: measurement.breast.toFixed(2),
                        legs: measurement.legs.toFixed(2),
                        rawPhotos: {
                            photoFront: measurement.photoFront,
                            photoSide: measurement.photoSide,
                            photoBack: measurement.photoBack,
                        },
                    });
                });
            });
            return measurements;
        };
        this.getMeasurementInfo = async (customerId) => {
            const { coachTrainee } = (await this.client.fetch("getMeasurementInfo", getMeasurementInfo_1.getMeasurementInfo, { id: parseInt(customerId) }));
            return coachTrainee;
        };
        this.client = client;
    }
}
exports.default = Measurements;
//# sourceMappingURL=Measurements.js.map